import React from 'react';
import {isEmail} from "../../utils/common-utils.ts";
import {getLabel} from "../../language/lang-utils.ts";


export const renderTextField = (inputData: { name: any; id: any; label: any; type: any; value?: string; required: boolean; autoComplete: any; inputMode: any; description: any; message: any, visible: boolean; errorMessageID: any}, value: string | number | readonly string[] | undefined, onChange: { (value: React.SetStateAction<string>): void; (value: React.SetStateAction<string>): void; (arg0: string): void; }, submitted: boolean) => {
    return (
        <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ?
                <span className='field_required'> ({getLabel("REQUIRED")})</span> : <span> ({getLabel("OPTIONAL")})</span>}</label>
            <div className='input_container input_container_text'>
                <input name={inputData.name}
                    id={inputData.id}
                    type={inputData.type}
                    value={value}
                    className={`medium ${inputData.required == true && !value && submitted ? "invalid" : ""}`}
                    {...inputData.required == true && !value && submitted ? { "aria-invalid": "true" } : {}}
                    {...inputData.required == true && !value && submitted ? { "aria-errormessage": inputData.errorMessageID } : {}}
                    autoComplete={inputData.autoComplete}
                    inputMode={inputData.inputMode}
                    aria-required={inputData.required}
                    aria-describedby={inputData.description}
                    onChange={(e) => onChange(e.target.value)}>
                </input>
                {inputData.message ? <p className={`sp_field_description ${submitted && inputData.required === true && !value ? "invalid" : inputData.visible === true ? "" : "hidden"}`} id={inputData.description}>{submitted && inputData.required === true && !value ? <img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> : ""}{inputData.message}</p> : ""}
            </div>
        </>
    );
};

export const renderTextArea = (inputData: { name: any; id: any; label: any; description: any; message: any; required: boolean; inputMode: any; visible: boolean; errorMessageID: any }, value: string | number | readonly string[] | undefined, onChange: { (value: React.SetStateAction<string>): void; (arg0: string): void; }, submitted: boolean) => {
    return (
        <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ?
                <span className='field_required'> ({getLabel("REQUIRED")})</span> : <span> ({getLabel("OPTIONAL")})</span>}</label>
            <div className='input_container input_container_textarea'>
               <textarea name={inputData.name}
                    id={inputData.id}
                    className={`textarea medium ${submitted && inputData.required == true && !value ? "invalid" : ""}`}
                    value={value}
                    {...submitted && inputData.required == true && !value ? { "aria-invalid": "true" } : {}}
                    {...submitted && inputData.required == true && !value ? { "aria-errormessage": inputData.errorMessageID } : {}}
                    aria-required={inputData.required}
                    inputMode={inputData.inputMode}
                    rows={10} cols={50}
                    aria-describedby={inputData.description}
                    onChange={(e) => onChange(e.target.value)}/>
                {inputData.message ? <p className={`sp_field_description ${submitted && inputData.required == true && !value ? "invalid" : inputData.visible == true ? "" : "hidden"}`} id={inputData.description}>{submitted && inputData.required === true && !value ? <img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> : ""}{inputData.message}</p> : ""}
            </div>
        </>
    );
};

export const renderEmailField = (inputData: { name: any; id: any; label: any; type?: string; required: boolean; description: any; visible: boolean; message: any; success: any; errorMessageID: any }, value: string | number | readonly string[] | undefined, onChange: { (value: React.SetStateAction<string>): void; (arg0: string): void; }, submitted: boolean) => {

    const condition1 = submitted && inputData.required == true && (!value || !isEmail(value));
    const condition2 = (!value && inputData.required == true) || (value && isEmail(value) && inputData.required == false);
    const condition3 = value && isEmail(value);
    return (
        <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ?
            <span className='field_required'> ({getLabel("REQUIRED")})</span> : <span> ({getLabel("OPTIONAL")})</span>}</label>
            <div className='input_container input_container_email'>
                <input
                    name={inputData.name}
                    id={inputData.id}
                    autoComplete='email'
                    type='email'
                    inputMode='email'
                    value={value}
                    className={`medium ${(submitted && inputData.required == true && !value) || (value && !isEmail(value)) ? "invalid" : ""}`}
                    aria-required={inputData.required}
                    {...submitted && (!value || (value && !isEmail(value))) ? { "aria-invalid": "true" } : {}}
                    {...submitted && (!value || (value && !isEmail(value))) ? { "aria-errormessage": inputData.errorMessageID } : {}}
                    aria-describedby="field_description_email"
                    onChange={(e) => onChange(e.target.value)}>
                </input>
            </div>
            {inputData.message ? <p className={`sp_field_description ${condition1 ? "invalid" : condition2 ? "" : "empty"}`} id={inputData.description} >{condition1 ? <img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> : ""}{condition3 ? inputData.success : inputData.message}</p> : ""}
        </>
    );
};

export const renderDropdown = (
    inputData: { id: string; name: string; label: string; option: any; required: boolean; message: string; description: string; visible: boolean; errorMessageID: any }, value: string | number | readonly string[] | undefined, onChange: { (value: React.SetStateAction<string>): void; (arg0: string): void; }, submitted: boolean) => {
    return (
        <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ?
                <span className='field_required'> ({getLabel("REQUIRED")})</span> : <span> ({getLabel("OPTIONAL")})</span>}</label>
            <div className='input_container input_container_select'>
                <select
                    name={inputData.name}
                    id={inputData.id}
                    className={`medium field_select ${submitted && inputData.required == true && (value === inputData.option[0].value || value === "select" || value === "") ? "invalid" : ""}`}
                    aria-required={inputData.required}
                    {...submitted && (value === inputData.option[0].value || value === "select" || value === "") ? { "aria-invalid": "true" } : {}}
                    {...submitted && (value === inputData.option[0].value || value === "select" || value === "") ? { "aria-errormessage": inputData.errorMessageID } : {}}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    aria-describedby={inputData.description}
                >
                    {inputData.option.map(({value, label}: any, i: any) => <option key={`${inputData.name}-${i}`}
                        value={value}>{label}</option>)}
                </select>
                {inputData.message ? <p className={`sp_field_description ${submitted && inputData.required == true && (value === inputData.option[0].value || value === "select" || value === "") ? "invalid" : inputData.visible == true ? "" : "hidden"}`} id={inputData.description}>{submitted && inputData.required === true && (value === inputData.option[0].value || value === "select" || value === "") ? <img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> : ""}{inputData.message}</p> : ""}
            </div>
        </>
    );
};